(function () {
  'use strict';

  var initializedSections = {};
  var youtubeApiPromise = null;

  function loadYouTubeApi() {
    if (youtubeApiPromise) return youtubeApiPromise;
    youtubeApiPromise = new Promise(function (resolve) {
      if (window.YT && window.YT.Player) { resolve(window.YT); return; }
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      document.head.appendChild(tag);
      window.onYouTubeIframeAPIReady = function () { resolve(window.YT); };
    });
    return youtubeApiPromise;
  }

  /* ── Stop all slides except one ── */
  function pauseAllExcept(sectionEl, exceptSlide) {
    sectionEl.querySelectorAll('[data-ac-slide].ac-playing').forEach(function (slide) {
      if (slide !== exceptSlide) stopSlide(slide);
    });
  }

  /* ── Stop a single slide ── */
  function stopSlide(slide) {
    slide.classList.remove('ac-playing');
    var container = slide.querySelector('[data-ac-video-container]');
    if (!container) return;
    var type = container.getAttribute('data-video-type');
    if (type === 'native') {
      var video = container.querySelector('video');
      if (video) video.pause();
      container.classList.remove('ac-active');
    } else if (type === 'youtube' && container._ytPlayer) {
      try { container._ytPlayer.pauseVideo(); } catch (e) {}
      container.classList.remove('ac-active');
    }
  }

  /* ── Play a single slide ── */
  function playSlide(slide) {
    var container = slide.querySelector('[data-ac-video-container]');
    if (!container) return;
    var type = container.getAttribute('data-video-type');

    if (type === 'native') {
      var video = container.querySelector('video');
      if (!video) return;
      container.classList.add('ac-active');
      video.play();
      slide.classList.add('ac-playing');

      video.addEventListener('ended', function onEnded() {
        stopSlide(slide);
        video.removeEventListener('ended', onEnded);
      });

    } else if (type === 'youtube') {
      var videoId = container.getAttribute('data-youtube-id');
      if (!videoId) return;

      function startYT() {
        container.classList.add('ac-active');
        slide.classList.add('ac-playing');
      }

      if (container._ytPlayer) {
        container._ytPlayer.playVideo();
        startYT();
        return;
      }

      loadYouTubeApi().then(function (YT) {
        container._ytPlayer = new YT.Player(container, {
          videoId: videoId,
          playerVars: { autoplay: 1, playsinline: 1, rel: 0 },
          events: {
            onReady: function (e) { e.target.playVideo(); startYT(); },
            onStateChange: function (e) {
              if (e.data === YT.PlayerState.ENDED) stopSlide(slide);
            }
          }
        });
      });
    }
  }

  /* ── Toggle play/pause on tap/click ── */
  function toggleSlide(sectionEl, slide) {
    if (slide.classList.contains('ac-playing')) {
      stopSlide(slide);
    } else {
      pauseAllExcept(sectionEl, slide);
      playSlide(slide);
    }
  }

  /* ── Mute toggle ── */
  function toggleMute(slide) {
    var container = slide.querySelector('[data-ac-video-container]');
    if (!container) return;
    var type = container.getAttribute('data-video-type');
    var muted = slide.classList.toggle('ac-muted');

    if (type === 'native') {
      var video = container.querySelector('video');
      if (video) video.muted = muted;
    } else if (type === 'youtube' && container._ytPlayer) {
      try {
        if (muted) container._ytPlayer.mute();
        else container._ytPlayer.unMute();
      } catch (e) {}
    }
  }

  /* ── Fullscreen toggle ── */
  function toggleFullscreen(slide) {
    var container = slide.querySelector('[data-ac-video-container]');
    var video = container ? container.querySelector('video') : null;
    var isFs = !!document.fullscreenElement;

    if (!isFs) {
      var target = video || slide;
      if (target.requestFullscreen) target.requestFullscreen();
      else if (target.webkitRequestFullscreen) target.webkitRequestFullscreen();
      slide.classList.add('ac-fullscreen');
    } else {
      if (document.exitFullscreen) document.exitFullscreen();
      else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
      slide.classList.remove('ac-fullscreen');
    }
  }

  document.addEventListener('fullscreenchange', function () {
    if (!document.fullscreenElement) {
      document.querySelectorAll('.ac-slide.ac-fullscreen').forEach(function (s) {
        s.classList.remove('ac-fullscreen');
      });
    }
  });

  /* ── Scroll one card ── */
  function scrollByOne(track, direction) {
    var slide = track.querySelector('[data-ac-slide]');
    if (!slide) return;
    var w = slide.getBoundingClientRect().width;
    var gap = parseFloat(getComputedStyle(track).gap) || 0;
    track.scrollBy({ left: (w + gap) * direction, behavior: 'smooth' });
  }

  /* ── Nav arrow state ── */
  function updateNav(sectionEl, track) {
    var prev = sectionEl.querySelector('.ac-nav--prev');
    var next = sectionEl.querySelector('.ac-nav--next');
    if (!prev && !next) return;
    var max = track.scrollWidth - track.clientWidth;
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max - 2;
  }

  /* ── Intersection Observer: pause when out of view ── */
  function setupVisibilityPause(sectionEl, track) {
    if (!('IntersectionObserver' in window)) return;

    var options = {
      root: track,
      threshold: 0.5  // slide must be ≥50% visible to stay playing
    };

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          var slide = entry.target;
          if (slide.classList.contains('ac-playing')) {
            stopSlide(slide);
          }
        }
      });
    }, options);

    track.querySelectorAll('[data-ac-slide]').forEach(function (slide) {
      observer.observe(slide);
    });
  }

  /* ── Main init ── */
  function initSection(sectionEl) {
    var track = sectionEl.querySelector('.alpha-carousel-track');
    if (!track) return;

    var prev = sectionEl.querySelector('.ac-nav--prev');
    var next = sectionEl.querySelector('.ac-nav--next');

    if (prev) prev.addEventListener('click', function () { scrollByOne(track, -1); });
    if (next) next.addEventListener('click', function () { scrollByOne(track, 1); });

    track.addEventListener('scroll', function () { updateNav(sectionEl, track); }, { passive: true });
    window.addEventListener('resize', function () { updateNav(sectionEl, track); });
    updateNav(sectionEl, track);

    /* Wheel → horizontal scroll */
    track.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
        e.preventDefault();
        track.scrollLeft += e.deltaY;
      }
    }, { passive: false });

    /* Keyboard */
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { scrollByOne(track, 1); e.preventDefault(); }
      if (e.key === 'ArrowLeft')  { scrollByOne(track, -1); e.preventDefault(); }
    });

    /* Mouse drag */
    var isDown = false, startX, scrollStart;
    track.addEventListener('mousedown', function (e) {
      isDown = true;
      startX = e.pageX;
      scrollStart = track.scrollLeft;
      track.style.scrollSnapType = 'none';
    });
    window.addEventListener('mouseup', function () {
      if (!isDown) return;
      isDown = false;
      track.style.scrollSnapType = '';
    });
    window.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      track.scrollLeft = scrollStart - (e.pageX - startX);
    });

    /* Per-slide events */
    track.querySelectorAll('[data-ac-slide]').forEach(function (slide) {
      /* Cards with content below the media need their outer wrapper to
         drop its fixed aspect-ratio/overflow so the card can grow to fit
         the video (at full, undistorted size) plus the text underneath.
         closest() finds that wrapper regardless of any markup Shopify
         inserts between it and the slide body. */
      if (slide.getAttribute('data-content-position') === 'below') {
        var card = slide.closest('.ac-slide');
        if (card) card.classList.add('ac-slide--below');
      }

      var mediaType = slide.getAttribute('data-media-type');
      if (mediaType !== 'video' && mediaType !== 'youtube') return;

      /* Tap to play/pause: the whole card when content overlays the media,
         or just the media area when content sits below it (so clicking the
         heading/text/button underneath doesn't trigger playback). */
      var contentPosition = slide.getAttribute('data-content-position');
      var clickTarget = (contentPosition === 'below' && slide.querySelector('.ac-slide-media'))
        ? slide.querySelector('.ac-slide-media')
        : slide;

      clickTarget.addEventListener('click', function (e) {
        /* Don't double-fire if mute/fullscreen/play-btn was clicked */
        if (
          e.target.closest('[data-ac-mute-btn]') ||
          e.target.closest('[data-ac-fullscreen-btn]') ||
          e.target.closest('[data-ac-play-btn]')
        ) return;
        toggleSlide(sectionEl, slide);
      });

      /* Play/pause button */
      var playBtn = slide.querySelector('[data-ac-play-btn]');
      if (playBtn) {
        playBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          toggleSlide(sectionEl, slide);
        });
      }

      /* Mute button */
      var muteBtn = slide.querySelector('[data-ac-mute-btn]');
      if (muteBtn) {
        muteBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          toggleMute(slide);
        });
      }

      /* Fullscreen button */
      var fsBtn = slide.querySelector('[data-ac-fullscreen-btn]');
      if (fsBtn) {
        fsBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          toggleFullscreen(slide);
        });
      }
    });

    /* Pause when scrolled out of view */
    setupVisibilityPause(sectionEl, track);
  }

  var AlphaCarousel = {
    init: function (sectionId) {
      var el = document.getElementById(sectionId);
      if (!el || initializedSections[sectionId]) return;
      initializedSections[sectionId] = true;
      initSection(el);
    }
  };

  window.AlphaCarousel = AlphaCarousel;

  /* Auto-init on script load */
  document.querySelectorAll('[data-alpha-carousel]').forEach(function (el) {
    AlphaCarousel.init(el.id);
  });
})();
